import { observer } from 'mobx-react'
import React from 'react'

export const ModalGroupTitle = observer(({ buttons, title }) => (
  <div className="qb-group-modal-title-wrapper">
    <div className="qb-group-modal-title-left">
      {buttons.map(button => button)}
    </div>
    <div className="qb-group-modal-title-center">
      <div className="qb-group-modal-title">{title}</div>
    </div>
  </div>
))
